export const QUERY_KEY_GRAPHHOPPER_ROUTE = 'graphhopper_route'